import React from 'react';
const tjtMontemar = require(`../assets/${process.env.PAGE}/img/tjt_mtm.png`);
const tjtMc = require(`../assets/${process.env.PAGE}/img/tjt_mc.png`);


import { formatMoney } from '../utils/utils.js';

require(`../assets/${process.env.PAGE}/css/components/new-credit-cards.css`);

const NewCreditCards = ({cards}) => {
    let singleCar = cards.length === 1;
    const creditCardDetails = cards.map((card) => {
        const colSize = singleCar ? '12' : '6';
        return (
            <div className={`col-lg-${colSize} col-md-${colSize} col-sm-${colSize} col-xs-${colSize} new_credit_cards_container`}>
                <div className={'credit_card_img'}>
                    <img src={card.type === 'mc' ? tjtMc : tjtMontemar}/>
                </div>
            </div>
        );
    })
    return (
        <div className='row new_credit_cards_wrapper'>
            <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                <p>Con tu préstamo también te llevás nuestro paquete de productos:</p>
            </div>
            {creditCardDetails}
            <div className={'col-lg-12 col-md-12 col-sm-12 col-xs-12'}>
                <p>Con los siguientes beneficios:</p>
                <p>
                    <i className="fa fa-check" aria-hidden="true"></i>
                    Tasas preferenciales para préstamos
                </p>
                <p>
                    <i className="fa fa-check" aria-hidden="true"></i>
                    Tarjeta Montemar para sacar adelantos
                </p>
                <p>
                    <i className="fa fa-check" aria-hidden="true"></i>
                    MasterCard para compras en todo el país
                </p>
                <p>
                    <i className="fa fa-check" aria-hidden="true"></i>
                    Plazos fijos con tasas más altas
                </p>
                <p>
                    <i className="fa fa-check" aria-hidden="true"></i>
                    Caja de ahorro en dólares gratuita
                </p>
                <p>
                    <i className="fa fa-check" aria-hidden="true"></i>
                    20% de descuento en tu Seguro Combinado Familiar
                </p>
                <p>
                    <i className="fa fa-check" aria-hidden="true"></i>
                    2 Meses bonificados del servicio
                </p>
                <p>
                    <i className="fa fa-check" aria-hidden="true"></i>
                    2 Meses bonificados del Servicio de Asistencia Montemar Tranqui!
                </p>
            </div>
        </div>
    );
}

export default NewCreditCards;


/** WEBPACK FOOTER **
 ** ./src/components/NewCreditCards.js
 **/